var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingscog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.14 12.94c.04-.3.06-.61.06-.94s-.02-.64-.06-.94l2.03-1.58c.18-.14.23-.39.12-.59l-1.92-3.32c-.11-.2-.34-.28-.56-.22l-2.39.96a7.007 7.007 0 0 0-1.63-.94L15 2.8a.486.486 0 0 0-.48-.4h-3.04c-.25 0-.45.18-.48.4l-.36 2.47c-.6.22-1.16.52-1.63.94l-2.39-.96a.506.506 0 0 0-.56.22L3.21 8.47c-.11.2-.06.45.12.59l2.03 1.58c-.04.3-.06.61-.06.94s.02.64.06.94l-2.03 1.58c-.18.14-.23.39-.12.59l1.92 3.32c.11.2.34.28.56.22l2.39-.96c.47.42 1.03.72 1.63.94l.36 2.47c.03.22.23.4.48.4h3.04c.25 0 .45-.18.48-.4l.36-2.47c.6-.22 1.16-.52 1.63-.94l2.39.96c.22.07.45-.02.56-.22l1.92-3.32c.11-.2.06-.45-.12-.59l-2.03-1.58zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingscog);
export default __webpack_public_path__ + "static/media/settingscog.03dfd423c7e24da30c9c13bce1f6498d.svg";
export { ForwardRef as ReactComponent };